import { Typography, Box, Grid, styled, Button, Stack, Tabs } from '@mui/material';
import Tab from '@mui/material/Tab';
import { ColorsV2 } from 'app/constants/color';

const CustomisedParentGrid = styled(Grid)({
  display: 'flex',
  gap: '0px',
  position: 'relative',
});
const CustomisedChildGrid = styled(Grid)({
  marginBottom: '20px',
  borderRadius: '16px',
  paddingTop: '5px',
  margin: '0px 20px 5px 20px',
  height: '100%',
  minHeight: '80vh',
});

const CustomisedPieChartContainer = styled(Box)({
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  flexDirection: 'column',
  marginTop: '5px',
});
const CustomisedChildGrid2 = styled(Grid)({
  height: '95%',
  marginBottom: '20px',
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'start',
  boxSizing: 'border-box',
  flexDirection: 'column',
  position: 'absolute',
  right: '0',
});
const PolarAreaChartContainer = styled(Box)({
  height: '500px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  paddingLeft: '20px',
});

const LineChartContainer = styled(Box)({
  width: '170%',
  overflow: 'hidden',
  marginTop: '2%',
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '2% 0 0 2%',
  marginLeft: '5%',
});

const Box1Heading = styled(Typography)({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '16px',
  color: ' #4A5F75',
  marginBottom: '20px',
});
const Box1Text = styled(Typography)({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: '500',
  fontSize: '36px',
  lineHeight: '42px',
  color: ' #000000',
  marginBottom: '25px',
  marginTop: '15px',
});

const CustomisedNContainers = styled(Box)({
  // width: '100px',
  height: '30px',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px',
  cursor: 'pointer',
});
const CusomisedNText = styled(Typography)({
  fontFamily: 'Roboto, sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: '#1E1B39',
  // textDecoration: 'line-through',
});
const CustomisedActionsContainer = styled(Box)({
  width: '80%',
  borderRadius: '5px',
  boxSizing: 'border-box',
  gap: '20px',
});
const CustomisedActionsContainerHeading = styled(Typography)({
  fontFamily: 'Lato, sans-serif',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '20px',
});
const CustomisedActionsContainerDesc = styled(Typography)({
  fontFamily: 'Nunito Sans, sans-serif',
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: '16px',
  color: '#8F95B2',
});

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: '64px',
});

const TopChildGrid = styled(Grid)({
  margin: '20px 20px 7px 20px',
  display: 'flex',
  justifyContent: 'space-between',
});

const HeadingContainer = styled(Box)({
  height: '105px',
  display: 'flex',
  alignItems: 'center',
});

const Title = styled(Typography)({
  fontFamily: 'Roboto, sans-serif',
  fontSize: '48px',
  lineHieght: '48px',
  fontWeight: '500',
});

const GenerateReportButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
});

const CustomisedGenerateReportButton = styled(Button)({
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: '700',
  fontFamily: 'Lato, sans-serif',
  height: '46px',
  boxShadow: '0px 8px 16px rgba(143, 149, 178, 0.15)',
  borderRadius: '8px',
  right: '20px',
  textTransfom: 'capitalize',
  position: 'absolute',
  gap: '10px',
});

const TabContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  boxSizing: 'border-box',
  marginTop: '14px',
  borderBottom: 1,
});

const CustomisedTab = styled(Tab)({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '700',
  fontFamily: 'Roboto, sans-serif',
  color: '#8F95B2',
});

const ClearFilterButtonContainer = styled(Box)({
  border: '1px solid #8F95B2',
  borderRadius: '6px',
  height: '30px',
  width: '130px',
  marginRight: '10px',
});

const CustomisedClearFilterButton = styled(Button)({
  gap: '5px',
  textTransform: 'capitalize',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
});

const NoDataContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
});

const NoDataImgContainer = styled(Box)({
  height: '400px',
  width: '400px',
});

const NoDataText = styled(Typography)({
  textAlign: 'center',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '28px',
  fontWeight: 'bold',
  letterSpacing: '2px',
});

const LineChartContainerParentGrid = styled(Grid)({
  width: '105%',
  height: '60px',
});

const LineChartContainerChildGrid = styled(Grid)({
  width: '40%',
  padding: '0.5% 0 1% 6%',
  display: 'flex',
  gap: '40px',
  boxSizing: 'border-box',
  alignItems: 'center',
  height: '100%',
});

const LineChartContainerHeading = styled(Typography)({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 700,
  fontSize: '16px',
  lineHieght: '19px',
});

const LineChartContainerChildGrid2 = styled(Grid)({
  width: '55%',
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '-8px',
});

const ParentDropdownStack = styled(Stack)({
  width: '95%',
  justifyContent: 'flex-end',
  padding: '0 20px 0 0',
});

const ParentNContainersStack = styled(Stack)({
  width: '100%',
  marginTop: '30px',
  marginBottom: '20px',
});

const CustomisedColoredContainer = styled(Box)({
  height: '8px',
  width: '21px',
});

const IdentityTableHeadingContainer = styled(Box)({
  width: '171.5%',
  height: '78px',
  borderRadius: '10px',
  marginLeft: '5%',
  marginTop: '7%',
  display: 'flex',
  justifyContent: 'center',
});

const IdentityTableHeadingStack = styled(Stack)({
  width: '90%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const IdentityTableHeading = styled(Typography)({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: '700',
  fontSize: '20px',
  lineHeight: '29px',
});

const IdentityTableContainer = styled(Box)({
  width: '171.5%',
  height: 'max-content',
  marginLeft: '5%',
  marginTop: '6%',
});

const NrOfScannedObjectsParentStack = styled(Stack)({
  marginTop: '50px',
  height: '321.67px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'start',
});

const CustomTabs = styled(Tabs)({
  marginTop: 5,
  padding: '2px 2px 2px 0px',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const CustomTab = styled(Tab)({
  border: `1px solid ${ColorsV2.white}`,
  borderRadius: '5px',
  color: ColorsV2.white,
  fontSize: '0.7em',
  background: 'transparent',
  fontWeight: 400,
  margin: '10px 10px 10px 0px',
  '&.MuiTab-root': {
    minHeight: '1em',
  },
  '&.Mui-selected': {
    color: ColorsV2.white,
    fontWeight: 700,
    background: ColorsV2.acent,
  },
});

export {
  TopChildGrid,
  HeadingContainer,
  CustomisedParentGrid,
  CustomisedChildGrid,
  CustomisedPieChartContainer,
  CustomisedChildGrid2,
  PolarAreaChartContainer,
  LineChartContainer,
  Box1Heading,
  Box1Text,
  CustomisedNContainers,
  CusomisedNText,
  CustomisedActionsContainer,
  CustomisedActionsContainerHeading,
  CustomisedActionsContainerDesc,
  Container,
  Title,
  GenerateReportButtonContainer,
  CustomisedGenerateReportButton,
  CustomisedClearFilterButton,
  TabContainer,
  CustomisedTab,
  ClearFilterButtonContainer,
  NoDataContainer,
  NoDataImgContainer,
  NoDataText,
  NrOfScannedObjectsParentStack,
  IdentityTableContainer,
  IdentityTableHeading,
  IdentityTableHeadingStack,
  IdentityTableHeadingContainer,
  CustomisedColoredContainer,
  ParentNContainersStack,
  ParentDropdownStack,
  LineChartContainerChildGrid2,
  LineChartContainerHeading,
  LineChartContainerChildGrid,
  LineChartContainerParentGrid,
  CustomTabs,
  CustomTab,
};
